import locale from 'localization';

export const accountColumns = [
  { key: 'category', text: 'Category', width: '10%' },
  { key: 'code', text: 'Code', width: '10%' },
  { key: 'name', text: locale.name, width: '15%' },
  { key: 'financialStatement', text: 'Financial Statement', width: '15%' },
  // { key: 'isPostable', text: 'Postable', width: '10%' },
  // { key: 'isAffectsCashflow', text: 'Affects Cashflow Statement', width: '10%' },
  { key: 'isCash', text: 'Treat as Cash', width: '10%' },
  { key: 'options', text: '', width: '5%' }
];
